import React from 'react';

import Pool from '../components/Pool';

interface Props {
    
}

const Stake = (props: Props) => {
    return (
        <div className='w-full flex justify-center'>
            <Pool />
        </div>
    )
}

export default Stake
